import React, { useState, useEffect } from 'react';
import { COLORS } from '../../constants/theme';

const MESSAGES = [
  'Searching your data…',
  'Almost there…',
  'Preparing your results…',
  'Putting it all together…',
  'Hang tight, almost done…',
];

const TypingIndicator = ({ showRetryMessage = false }) => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - start) / 1000));
    }, 500);
    return () => clearInterval(id);
  }, [showRetryMessage]);

  const msgIndex = Math.min(Math.floor(elapsed / 5), MESSAGES.length - 1);
  const currentMessage = MESSAGES[msgIndex];

  const raw = Math.min(elapsed / 20, 1);
  const pct = Math.round((1 - Math.pow(1 - raw, 2.5)) * 88);

  return (
    <div className="flex justify-start mb-6 animate-fade-in-up px-1">
      <div
        className="rounded-2xl shadow-sm overflow-hidden"
        style={{
          background: '#fff',
          border: '1px solid #ede8ec',
          minWidth: 260,
          maxWidth: 340,
        }}
      >
        {/* Body */}
        <div className="flex items-center gap-3 px-4 py-3.5">
          {/* Animated logo ring */}
          <div className="flex-shrink-0 relative w-8 h-8">
            <svg
              width="32" height="32" viewBox="0 0 32 32"
              className="animate-spin"
              style={{ animationDuration: '1.4s', position: 'absolute', inset: 0 }}
            >
              <circle
                cx="16" cy="16" r="13"
                fill="none"
                stroke={COLORS.primary}
                strokeWidth="2.5"
                strokeDasharray="60"
                strokeDashoffset="20"
                strokeLinecap="round"
                opacity="0.85"
              />
            </svg>
            <div
              className="absolute inset-0 flex items-center justify-center rounded-full"
              style={{ background: `${COLORS.primary}12` }}
            >
              <span style={{ fontSize: 13 }}>✦</span>
            </div>
          </div>

          {/* Text */}
          <div className="flex flex-col gap-0.5">
            <span className="text-sm font-semibold text-gray-800 leading-tight">
              {currentMessage}
            </span>
          </div>
        </div>

        {/* Progress bar */}
        <div className="h-0.5 w-full bg-gray-100">
          <div
            className="h-full transition-all duration-700 ease-out"
            style={{
              width: `${pct}%`,
              background: `linear-gradient(90deg, ${COLORS.primary}, ${COLORS.secondary})`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
